import React from 'react';

import PropTypes from 'prop-types';

import { styled, Stack } from '@mui/material';

import { COLORS } from '../../../Constant/COLORS';

import Header from '../../../Components/Header';

const ShadowedStack = styled(Stack)({
  marginLeft: 'auto',
  marginRight: 'auto',
  backgroundColor: COLORS.surface,
  border: `1px solid ${COLORS.hairline}`,
  boxShadow: '0 1px 2px rgba(14, 27, 31, 0.04), 0 18px 44px rgba(14, 27, 31, 0.08)',
  boxSizing: 'border-box',
});

const Layout = ({ children, ...rest }) => (
  <>
    {/* professional login header is same as RegisterProfessionalPages header */}
    <Header isRegisterProfessionalPage />
    <ShadowedStack
      sx={{
        borderRadius: { xs: '16px', md: '20px' },
        marginTop: { xs: '40px', md: '80px' },
      }}
      {...rest}
    >
      {children}
    </ShadowedStack>
  </>
);

Layout.propTypes = { children: PropTypes.node };

export default Layout;
